import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { EditorDemoStore } from '../EditorDemoStore';

interface SimplePlaybackControlsProps {
  demoStore: EditorDemoStore;
  duration: number;
}

export const SimplePlaybackControls = observer(({ demoStore, duration }: SimplePlaybackControlsProps) => {
  // Format time as MM:SS
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  
  return (
    <ControlsContainer>
      <ButtonGroup>
        <PlayButton onClick={() => demoStore.togglePlayback()}>
          {demoStore.isPlaying ? 'Pause' : 'Play'}
        </PlayButton>
      </ButtonGroup>
      <TimeDisplay>
        {formatTime(demoStore.currentTime)} / {formatTime(duration)}
      </TimeDisplay>
    </ControlsContainer>
  );
});

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: #171724;
  border-radius: 4px;
  margin-bottom: 16px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const PlayButton = styled.button`
  padding: 8px 16px;
  background-color: #006FEE;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #0053D9;
  }
`;

const TimeDisplay = styled.div`
  color: white;
  margin-top: 8px;
  font-family: monospace;
`;